module.exports = __webpack_public_path__ + "img/sec12desk.1ba5f55b.png";